import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import { DeleteButton } from './style';
import useSavedDatasets from '../../../../hooks/useSavedDatasets';

function DeleteDatasetDialog({
  datasetId,
  datasetName,
  open,
  handleClose,
}) {
  const { deleteDatasetById } = useSavedDatasets();
  const [isDeleting, setIsDeleting] = useState(false);
  const [isInvalid, setIsInvalid] = useState(true);
  const [errorText, setErrorText] = useState('');

  const handleDeleteValidation = (event) => {
    const { value } = event.target;
    const isInvalidValue = datasetName.toLowerCase().trim() !== value.toLowerCase().trim();
    setErrorText('');
    setIsInvalid(isInvalidValue);
  };

  const handleDeleteDataset = () => {
    setIsDeleting(true);
    setErrorText('');
    try {
      deleteDatasetById(datasetId);
      handleClose(true);
      setIsDeleting(false);
    } catch (error) {
      console.error(error);
      setErrorText('An error occurred while deleting dataset.');
    }
  };

  const onCloseCancel = () => {
    if (isDeleting) return;
    handleClose();
  };

  return (
    <Dialog id="dataset-delete-dialog" open={open} onClose={onCloseCancel}>
      <DialogTitle>
        Delete
        {datasetName}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pb: '1rem' }}>
          <Typography id={`delete-dataset-name-${datasetId}`}>
            Deleting this shared data set (
            <b>{datasetName}</b>
            ) will permanently remove it for
            everyone, not just you.
            <br />
            To move forward with the irreversible deletion of this data set, type (
            <b>{datasetName}</b>
            ) in the field below and then click delete.
          </Typography>
        </Box>
        <TextField
          autoComplete="off"
          required
          margin="dense"
          id="name"
          name="name"
          label="Dataset name"
          type="text"
          fullWidth
          variant="outlined"
          error={isInvalid || !!errorText}
          size="small"
          placeholder={datasetName}
          InputLabelProps={{ shrink: true }}
          onChange={handleDeleteValidation}
          helperText={errorText}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="inherit"
          variant="contained"
          disableElevation
          onClick={onCloseCancel}
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <DeleteButton
          id="dataset-delete-dialog-delete-button"
          color="error"
          variant="contained"
          disabled={isDeleting || isInvalid}
          disableElevation
          onClick={handleDeleteDataset}
        >
          Delete
          {isDeleting && <CircularProgress color="error" size="1.2rem" />}
        </DeleteButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteDatasetDialog;
